// routes/generator.upscaler.tsx
import { getI18n } from 'src/i18n/i18n.middleware'
import { dynamic } from 'src/utils/ssr'
import { staticMeta, staticMetaLoader } from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/generator.upscaler'

const getClientModule = () => import('src/clientRoutes/generator.upscaler')

export const handle = {
  name: 'generator/upscaler',
  track: { scene: 'upscale' },
}

export function loader({ request, context }: Route.LoaderArgs) {
  const { t } = getI18n(context)
  return staticMetaLoader({
    requestUrl: request.url,
    title: t('server:meta.home.title'),
  })
}

export function meta({ loaderData }: Route.MetaArgs) {
  return staticMeta(loaderData)
}

export default dynamic(getClientModule, { ssr: false })
